<template>
  <div class="overflow: auto">
    <div style="display: flex; flex-wrap: wrap">
      <div class="search_list">
        <div class="text">姓名/账号:</div>
        <Input v-model="keyword" @input="changeInput()" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">团队名称:</div>
        <Input v-model="groupName1" @input="changeInput()" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">选择状态:</div>
        <Select v-model="state" @on-change="changeInput" class="select">
          <Option v-for="item in types" :value="item.value" :key="item.value">
            {{
            item.label
            }}
          </Option>
        </Select>
      </div>
      <div class="search_list">
        <div class="text">按时间查询:</div>
        <DatePicker type="daterange" split-panels class="select" @on-change="queryTime"></DatePicker>
      </div>
    </div>
    <Table style="font-size: 20px" :content="self" border stripe :columns="columns1" :data="data1">
      <template slot-scope="{ row, index }" slot="isMaster">
        <span v-if="row.isMaster == 0">否</span>
        <span v-if="row.isMaster == 1">是</span>
        <span v-if="row.isMaster == 2">取系统等级</span>
      </template>
      <template slot-scope="{ row, index }" slot="rewardAmt">{{row.rewardAmt/100}}</template>
      <template slot-scope="{ row, index }" slot="surplusAmt">{{row.surplusAmt/100}}</template>
      <template slot-scope="{ row, index }" slot="drawAmt">{{row.drawAmt/100}}</template>

      <template slot-scope="{ row, index }" slot="forbid">
        <Button
          style="background: red; border-color: red; margin-left: 10px"
          type="error"
          v-if="row.state == '正常'"
          size="small"
          @click="forbid(row)"
        >禁用</Button>
        <Button
          style="background: green; border-color: green; margin-left: 10px"
          type="error"
          v-if="row.state == '已冻结'"
          size="small"
          @click="forbid(row)"
        >启用</Button>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          style="background: #1e88e5; border-color: #1e88e5"
          type="error"
          size="small"
          @click="
            showConfig = true;
            dataIndex = index;
            amend(row.id);
          "
        >修改</Button>
        <Button
          style="background: #1e88e5; border-color: #1e88e5"
          type="error"
          size="small"
          v-if="row.idNo"
          @click="
            SettlementCardList(row.id);
            showConfig5 = true;
          "
        >删除银行卡</Button>
        <Button
          style="background: #1e88e5; border-color: #1e88e5"
          type="error"
          size="small"
          @click="
            showConfig1 = true;
            dataIndex = index;
            amend(row.id);
          "
        >修改实名</Button>
        <Button
          style="background: #1e88e5; border-color: #1e88e5"
          type="error"
          size="small"
          @click="
            showUser = true;
            userChain(row.id);
          "
        >用户链</Button>
        <Button
          v-if="row.idNo"
          style="background: #1e88e5; border-color: #1e88e5"
          type="error"
          size="small"
          @click="dataIndex = index;showConfig3=true;"
        >删除实名</Button>
        <!-- <Button
          style="background: #1e88e5; border-color: #1e88e5"
          type="error"
          size="small"
          @click="
            upData = row;
            changeInput1();
            tanchuang = true;
          "
          >绑定产品</Button
        >-->
      </template>
    </Table>
    <Page style="margin-top: 10px" :total="total" @on-change="pagingSuery" show-elevator />
    <Button
      style="
        background: #2d8cf0;
        border-color: #2d8cf0;
        float: right;
        padding: 8px 30px;
        font-size: 20px;
      "
      type="error"
      size="small"
      @click="
        AddUser = true;
        title = '添加团队';
        username = '';
        groupName = '';
        phone = '';
      "
    >添加团队</Button>
    <Modal
      width="40"
      v-model="showConfig6"
      title="删除银行卡"
      @on-ok="SettlementCardDel()"
    >删除卡：{{CardDel.cardNo}}</Modal>
    <Modal width="40" v-model="showConfig5" title="删除银行卡">
      <Table
        style="font-size: 20px"
        :content="self"
        border
        stripe
        :columns="columns4"
        :data="tlementCardList"
      >
        <template slot-scope="{ row, index }" slot="config">
          <Button
            style="background: #2d8cf0; border-color: #2d8cf0"
            type="error"
            size="small"
            @click="CardDel=row;showConfig6=true"
          >删除</Button>
        </template>
      </Table>
    </Modal>
    <Modal width="40" v-model="showConfig3" title="删除" @on-ok="CleanRealName(data1[dataIndex])">删除</Modal>
    <Modal width="40" v-model="showConfig1" title="修改" @on-ok="Config1(data1[dataIndex])">
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">用户名称：</div>
      <Input style="width: 200px" v-model="data1[dataIndex].username" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">身份证号:</div>
      <Input style="width: 200px" v-model="data1[dataIndex].idNo" />
    </Modal>
    <Modal width="40" v-model="showConfig" title="修改" @on-ok="Config(data1[dataIndex])">
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">用户名称：</div>
      <Input style="width: 200px" v-model="data1[dataIndex].username" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">团队名称:</div>
      <Input style="width: 200px" v-model="data1[dataIndex].groupName" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">身份证号:</div>
      <Input style="width: 200px" v-model="data1[dataIndex].idNo" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">手机号码：</div>
      <Input style="width: 200px" v-model="data1[dataIndex].phone" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">团队管理:</div>
      <RadioGroup v-model="data1[dataIndex].isMaster">
        <Radio :label="1">是</Radio>
        <Radio :label="0">否</Radio>
        <Radio :label="2">取系统等级</Radio>
      </RadioGroup>
    </Modal>
    <Modal width="40" v-model="AddUser" :title="title" @on-ok="Add()">
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">用户名称：</div>
      <Input style="width: 200px" v-model="username" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">团队名称：</div>
      <Input style="width: 200px" v-model="groupName" />
      <br />
      <br />
      <div style="float: left; width: 80px; height: 32px; line-height: 32px">手机号码：</div>
      <Input style="width: 200px" v-model="phone" />
    </Modal>

    <Modal width="1000" v-model="tanchuang" title="绑定产品">
      <div
        style="
          display: flex;
          align-items: center;
          margin-left: 15px;
          margin-bottom: 15px;
        "
      >
        <div style="width: 100px">产品分组:</div>
        <Select v-model="productGroupId" @on-change="changeInput1()">
          <Option
            v-for="(data, index) in ProductGroupQueryList"
            :key="index"
            :value="data.id"
          >{{ data.name }}</Option>
        </Select>
      </div>

      <Table
        style="font-size: 20px"
        :content="self"
        border
        stripe
        :columns="columns3"
        :data="QueryBindProductList"
      >
        <template slot-scope="{ row, index }" slot="productLogo">
          <img style="width: 30px" :src="row.productLogo" alt srcset />
        </template>
        <template slot-scope="{ row, index }" slot="isBind">
          <span v-if="row.isBind == 0">否</span>
          <span v-if="row.isBind == 1">是</span>
        </template>

        <template slot-scope="{ row, index }" slot="action">
          <Button
            v-if="row.isBind == 1"
            style="background: red; border-color: red"
            type="error"
            size="small"
            @click="badding(row, 0)"
          >解除绑定</Button>
          <Button
            v-if="row.isBind == 0"
            style="background: #2d8cf0; border-color: #2d8cf0"
            type="error"
            size="small"
            @click="badding(row, 1)"
          >绑定</Button>
        </template>
      </Table>
    </Modal>

    <Modal width="40" v-model="showUser" title="用户链">
      <Table
        style="font-size: 20px"
        :content="self"
        border
        stripe
        :columns="columns2"
        :data="userData"
      >
        <template slot-scope="{ row, index }" slot="roundDown">
          <Icon type="md-arrow-round-down" />
        </template>
      </Table>
    </Modal>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "GroupConfig",

  data() {
    return {
      upData: {},
      ProductGroupQueryList: [],
      tanchuang: false,
      showUser: false,
      CardDel: {},
      tlementCardList: [],
      showConfig6: false,
      showConfig3: false,
      productGroupId: "",
      title: "",
      showConfig1: false,
      username: "",
      phone: "",
      columns4: [
        {
          title: "卡号",
          align: "center",
          key: "cardNo"
        },
        {
          title: "预留手机号",
          align: "center",
          key: "mobileNo"
        },
        {
          title: "绑定时间",
          align: "center",
          key: "createTime"
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "config"
        }
      ],
      groupName: "",
      columns3: [
        {
          title: "图片",
          slot: "productLogo",
          align: "center"
        },
        {
          title: "产品名称",
          align: "center",
          key: "productName"
        },
        {
          title: "是否已绑定",
          key: "address",
          align: "center",
          slot: "isBind"
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "action"
        }
      ],
      columns2: [
        {
          title: "链",
          key: "address",
          align: "center",
          slot: "roundDown"
        },
        {
          title: "用户名",
          align: "center",
          key: "username"
        },
        {
          title: "手机号",
          key: "phone",
          align: "center"
        },
        {
          title: "创建时间",
          align: "center",
          key: "createTime"
        }
      ],

      showConfig5: false,
      groupName1: "",
      pageNow: 0,
      AddUser: false,
      keyword: "",
      dataIndex: 0,
      showConfig: false,
      time: [],
      types: [
        {
          value: "0",
          label: "已冻结"
        },
        {
          value: "1",
          label: "正常"
        }
      ],
      state: "",
      userData: [],
      self: this,
      total: 0,
      columns1: [
        {
          title: "用户名",
          align: "center",
          key: "username",
          width: 200
        },
        {
          title: "手机号",
          key: "phone",
          align: "center",
          width: 200
        },
        {
          title: "团队名称",
          align: "center",
          key: "groupName",
          width: 200
        },
        {
          title: "状态",
          key: "address",
          align: "center",
          slot: "forbid",
          width: 200
        },
        {
          title: "总收益",
          key: "address",
          align: "center",
          slot: "rewardAmt",
          width: 200
        },
        {
          title: "账户余额",
          key: "address",
          align: "center",
          slot: "surplusAmt",
          width: 200
        },
        {
          title: "已提金额",
          key: "address",
          align: "center",
          slot: "drawAmt",
          width: 200
        },

        {
          title: "创建时间",
          align: "center",
          key: "createTime",
          width: 200
        },

        {
          title: "是否为团队管理 ",
          align: "center",
          slot: "isMaster",
          width: 200
        },

        {
          title: "终端 ",
          align: "center",
          key: "terminal",
          width: 200
        },
        {
          title: "证件号码 ",
          align: "center",
          width: 200,
          key: "idNo"
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "action",
          width: 400,
          fixed: "right"
        }
      ],
      data1: [{}],
      QueryBindProductList: []
    };
  },
  mounted: function() {
    this.getData();
  },
  activated: function() {
    this.getData();
  },
  methods: {
    SettlementCardList(userId) {
      api.SettlementCardList(userId).then(res => {
        this.tlementCardList = res.body.data;
      });
    },
    SettlementCardDel() {
      api.SettlementCardDel(this.CardDel.id).then(res => {
        alert(res.body.message);
        this.showConfig5 = false;
      });
    },
    CleanRealName(data) {
      api.CleanRealName(data.id).then(res => {
        this.getData();
        this.$layer.alert(res.body.message);
      });
    },
    badding(row, i) {
      api
        .ProducBatchBind({
          bindUserId: this.upData.id,
          products: [
            {
              id: row.id,
              isBind: i
            }
          ]
        })
        .then(res => {
          alert(res.body.message);
          this.changeInput1();
        });
    },

    userChain(id) {
      api.UserChain(id).then(res => {
        this.userData = res.body.data;
      });
    },
    forbid(row) {
      api.UserFrozen(row.id).then(data => {
        this.getData();
      });
    },
    amend(id) {
      api.UserGet(id).then(res => {
        this.data1[this.dataIndex] = res.body.data;
        this.$forceUpdate();
      });
    },
    Config(data) {
      // if (data.IsMaster == "否") {
      //   data.isMaster = 0;
      // } else if (data.IsMaster == "是") {
      //   data.isMaster = 1;
      // } else {
      //   data.isMaster = 2;
      // }
      api
        .UserEdit({
          id: data.id,
          username: data.username,
          groupName: data.groupName,
          phone: data.phone,
          idNo: data.idNo,
          isMaster: data.isMaster
        })
        .then(res => {
          this.getData();
          this.$layer.alert(res.body.message);
        });
    },
    Config1(data) {
      api
        .UserEdit({
          id: data.id,
          username: data.username,
          idNo: data.idNo
        })
        .then(res => {
          this.getData();
          this.$layer.alert(res.body.message);
        });
    },
    queryTime(time) {
      this.time[0] = Date.parse(new Date(time[0])) - 28800000;
      this.time[1] = Date.parse(new Date(time[1])) - 28800000 + 86400000;
      this.getData(this.keyword);
    },
    getData() {
      api
        .ProductGroupQueryList({
          pageNow: 1,
          pageSize: 999999
        })
        .then(res => {
          this.ProductGroupQueryList = res.body.data.list;
        });
      api
        .UserList({
          pageNow: this.pageNow,
          pageSize: 10,
          keyword: this.keyword,
          groupName: this.groupName1,
          state: this.state,
          startMillis: this.time[0],
          endMillis: this.time[1]
        })
        .then(res => {
          if (res.body.data.list.length == 0) {
            this.data1 = [{}];
          } else {
            this.total = res.body.data.total;
            this.data1 = res.body.data.list;
            this.data1.forEach(element => {
              if (element.state == 0) {
                element.state = "已冻结";
              }
              if (element.state == 1) {
                element.state = "正常";
              }
              // if (element.isMaster == 0) {
              //   element.isMaster = "否";
              // }
              // if (element.isMaster == 1) {
              //   element.isMaster = "是";
              // }
            });
          }
        });
    },
    Add() {
      api
        .UserAdd({
          username: this.username,
          groupName: this.groupName,
          phone: this.phone
        })
        .then(() => {
          this.getData();
        });
    },
    changeInput() {
      this.pageNow = 0;
      this.getData();
    },
    changeInput1() {
      api
        .QueryBindProductList(this.productGroupId, this.upData.id)
        .then(res => {
          this.QueryBindProductList = res.body.data;
        });
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    }
  }
};
</script>

<style scoped lang = 'less'>
</style>